<template>
  <span class="placeholder-text">
    <template v-for="(segment, index) in segments" :key="index">
      <mark v-if="segment.placeholder" class="placeholder-text__slot">{{ segment.text }}</mark>
      <template v-else>{{ segment.text }}</template>
    </template>
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { placeholderSegments } from '~/utils/content-placeholders';

const props = defineProps<{ text: string | null | undefined }>();

const segments = computed(() => placeholderSegments(props.text));
</script>

<style scoped lang="scss">
.placeholder-text {
  white-space: inherit;
}

.placeholder-text__slot {
  /* A fill-in slot, distinct from body text, in solid tokens (Ben Q42, cas-23e8 D17): the
     soft green fill alone barely separates from a dark card, so the slot's words take the
     green text ink too. */
  background: var(--g-accent-soft);
  color: var(--g-accent-text);
  border-radius: 4px;
  padding: 0 2px;
}
</style>
